import GiftCodeIndexPage from '../../../components/organism/mypages/gift_codes/GiftCodeIndexPage.vue'

export default {
  components: {
    GiftCodeIndexPage
  }
}
